import React from 'react';
import PropTypes from 'prop-types';

import {red500} from "assets/jss/main";

ErrorCount.propTypes = {
    count: PropTypes.number
};

const CrossIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={red500}
         strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-circle-x h-3 w-3">
        <circle cx="12" cy="12" r="10"></circle>
        <path d="m15 9-6 6"></path>
        <path d="m9 9 6 6"></path>
    </svg>
)

function ErrorCount({count}) {
    if (count > 0) {
        return (
            <div style={{
                display: 'flex',
                gap: '4px',
                alignItems: 'center',
                fontWeight: 600,
                color: red500
            }}>
                <CrossIcon /> {count}
            </div>
        );
    }

    return (
        <div style={{color: '#6b7280'}}>0</div>
    )
}

export default ErrorCount;
